import { Injectable } from '@angular/core';
import { ContentBlock } from '@app/shared/cms/models';
import {FAQPage, Question, WithContext} from 'schema-dts';

@Injectable({
  providedIn: 'root'
})
export class SeoService {

  constructor() { }
  
  createCanonicalLink() {
    let link: HTMLLinkElement = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
    link.setAttribute('href', `${location.protocol}//${location.host}${location.pathname}`);
  }
  clearCanonicalLinks() {
    const els = document.querySelectorAll('link[rel=\'canonical\']');
    for (let i = 0, l = els.length; i < l; i++) {
      const el = els[i];
      el.remove();
    }
  }
  injectStructuredDataScript(contentBlocks: ContentBlock[], id: string) {
    const questions = [];
    contentBlocks.forEach(block => {
      const faqQuestion: Question = {       
        "@type": "Question",
        name: block.name,
        acceptedAnswer: {
          "@type": 'Answer',
          text: block.content?.replace(/\\n/g, "\\n")
                              .replace(/\\'/g, "\\'")
                              .replace(/\\"/g, '\\"')
                              .replace(/\\&/g, "\\&")
                              .replace(/\\r/g, "\\r")
                              .replace(/\\t/g, "\\t")
                              .replace(/\\b/g, "\\b")
                              .replace(/\\f/g, "\\f")
        }
      };
      questions.push(faqQuestion);      
    });
    const faqPage : WithContext<FAQPage> = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: questions     
    };    
    let scriptElement: HTMLScriptElement = document.createElement('script');
    scriptElement.type="application/ld+json";
    scriptElement.id = id;
    scriptElement.text=JSON.stringify(faqPage);
    document.head.appendChild(scriptElement);
  }
  clearElementById(id) {
    const el = document.getElementById(id);
    if(el) {
      el.remove();
    }
  }
}
